import { useMediaQuery } from '@mui/material'

// This is not the same as useIsMobileWidth, as we want to show tables on tablets, but cards on mobile
export const useShowCardsOnDashboard = () => {
  return useMediaQuery((theme) => theme.breakpoints.down('sm'))
}
